import { Directive } from '@angular/core';

/*
 *
 */
@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'mk-box-small-footer'
})
export class BoxSmallFooterDirective {}


/*
 *
 */
@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'mk-box-small-header'
})
export class BoxSmallHeaderDirective {}

/*
 *
 */
@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'mk-box-small-content'
})
export class BoxSmallContentDirective {}
